(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-wishlist-campaign-2026"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('ls-wishlist-campaign-2026')) return;
  class LoveShopWishlistCampaign extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._boundaries = ['start', 'weekend', 'cyber', 'end'].map(key => Date.parse(this.dataset[key]));
      this._labels = {
        heading: this.querySelector('[data-countdown-label]'),
        date: this.querySelector('[data-countdown-date]'),
        note: this.querySelector('[data-countdown-note]')
      };
      this._digits = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector('[data-' + key + ']'));
      this._onVisibility = () => {
        clearInterval(this._interval);
        this._interval = null;
        if (!document.hidden) this.start();
      };
      document.addEventListener('visibilitychange', this._onVisibility);
      this.start();
    }
    disconnectedCallback() {
      clearInterval(this._interval);
      document.removeEventListener('visibilitychange', this._onVisibility);
      this._connected = false;
    }
    start() {
      clearInterval(this._interval);
      this._interval = null;
      this.update();
      if (this.dataset.phase !== 'ended' && !document.hidden) {
        this._interval = setInterval(() => this.update(), this.dataset.mode === 'hero' ? 1000 : 10000);
      }
    }
    update() {
      const now = Date.now();
      let stage = this.dataset.enabled === 'false' || this._boundaries.some(value => !Number.isFinite(value)) ? 4 : this._boundaries.findIndex(value => now < value);
      if (stage < 0) stage = 4;
      const phase = ['upcoming', 'black_friday', 'weekend', 'cyber_monday', 'ended'][stage];
      if (this._phase !== phase) {
        this._phase = phase;
        this.dataset.phase = phase;
        this.querySelectorAll('[data-campaign]').forEach(element => { element.hidden = stage === 4; });
        this.querySelectorAll('[data-evergreen]').forEach(element => { element.hidden = stage !== 4; });
        if (stage < 4) {
          const key = phase.replace(/_/g, '-');
          if (this._labels.heading) this._labels.heading.textContent = this.getAttribute('data-label-' + key) || '';
          if (this._labels.date) this._labels.date.textContent = this.getAttribute('data-date-' + key) || '';
          if (this._labels.note) this._labels.note.textContent = this.getAttribute('data-note-' + key) || '';
        }
        const offerIndex = Math.max(1, Math.min(stage, 3));
        ['title', 'date', 'channel'].forEach(part => {
          const element = this.querySelector('[data-poster-' + part + ']');
          if (element) element.textContent = this.getAttribute('data-poster-' + part + '-' + offerIndex) || '';
        });
        const posterNumber = this.querySelector('[data-poster-number]');
        if (posterNumber) posterNumber.textContent = ['40', '20', '30'][offerIndex - 1];
        const posterWhisper = this.querySelector('[data-poster-whisper]');
        if (posterWhisper) posterWhisper.hidden = stage > 1;
        const posterChannel = this.querySelector('[data-poster-channel]');
        if (stage === 3 && posterChannel) posterChannel.textContent += ' · ' + (this.dataset.posterShipping || '');
        this.querySelectorAll('[data-offer-index]').forEach(card => {
          const offerStage = Number(card.dataset.offerIndex);
          card.dataset.active = stage === offerStage ? 'true' : 'false';
          const badge = card.querySelector('[data-offer-status]');
          if (badge) badge.textContent = stage > offerStage ? this.dataset.ended : stage === offerStage ? this.dataset.live : this.dataset.soon;
        });
      }
      if (stage === 4) {
        clearInterval(this._interval);
        this._interval = null;
        return;
      }
      if (this.dataset.mode !== 'hero') return;
      const remaining = Math.max(0, Math.ceil((this._boundaries[stage] - now) / 1000));
      const values = [
        Math.floor(remaining / 86400),
        Math.floor(remaining % 86400 / 3600),
        Math.floor(remaining % 3600 / 60),
        remaining % 60
      ];
      this._digits.forEach((element, index) => {
        if (!element) return;
        const value = String(values[index]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      });
    }
  }
  customElements.define('ls-wishlist-campaign-2026', LoveShopWishlistCampaign);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-wishlist-holiday"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ls-wishlist-campaign')) return;
  class LoveShopWishlistCampaign extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._boundaries = ['start', 'weekend', 'cyber', 'end'].map(key => Date.parse(this.dataset[key]));
      this._labels = {
        heading: this.querySelector('[data-countdown-label]'),
        date: this.querySelector('[data-countdown-date]'),
        note: this.querySelector('[data-countdown-note]')
      };
      this._digits = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector('[data-' + key + ']'));
      this._onVisibility = () => {
        clearInterval(this._interval);
        this._interval = null;
        if (!document.hidden) this.start();
      };
      document.addEventListener('visibilitychange', this._onVisibility);
      this.start();
    }
    disconnectedCallback() {
      clearInterval(this._interval);
      document.removeEventListener('visibilitychange', this._onVisibility);
      this._connected = false;
    }
    start() {
      clearInterval(this._interval);
      this._interval = null;
      this.update();
      if (this.dataset.phase !== 'ended' && !document.hidden) {
        this._interval = setInterval(() => this.update(), this.dataset.mode === 'hero' ? 1000 : 10000);
      }
    }
    update() {
      const now = Date.now();
      let stage = this.dataset.enabled === 'false' || this._boundaries.some(value => !Number.isFinite(value)) ? 4 : this._boundaries.findIndex(value => now < value);
      if (stage < 0) stage = 4;
      const phase = ['upcoming', 'black_friday', 'weekend', 'cyber_monday', 'ended'][stage];
      if (this._phase !== phase) {
        this._phase = phase;
        this.dataset.phase = phase;
        this.querySelectorAll('[data-campaign]').forEach(element => { element.hidden = stage === 4; });
        this.querySelectorAll('[data-evergreen]').forEach(element => { element.hidden = stage !== 4; });
        if (stage < 4) {
          const key = phase.replace(/_/g, '-');
          if (this._labels.heading) this._labels.heading.textContent = this.getAttribute('data-label-' + key) || '';
          if (this._labels.date) this._labels.date.textContent = this.getAttribute('data-date-' + key) || '';
          if (this._labels.note) this._labels.note.textContent = this.getAttribute('data-note-' + key) || '';
        }
        this.querySelectorAll('[data-offer-index]').forEach(card => {
          const offerStage = Number(card.dataset.offerIndex);
          card.dataset.active = stage === offerStage ? 'true' : 'false';
          const badge = card.querySelector('[data-offer-status]');
          if (badge) badge.textContent = stage > offerStage ? this.dataset.ended : stage === offerStage ? this.dataset.live : this.dataset.soon;
        });
      }
      if (stage === 4) {
        clearInterval(this._interval);
        this._interval = null;
        return;
      }
      if (this.dataset.mode !== 'hero') return;
      const remaining = Math.max(0, Math.ceil((this._boundaries[stage] - now) / 1000));
      const values = [
        Math.floor(remaining / 86400),
        Math.floor(remaining % 86400 / 3600),
        Math.floor(remaining % 3600 / 60),
        remaining % 60
      ];
      this._digits.forEach((element, index) => {
        if (!element) return;
        const value = String(values[index]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      });
    }
  }
  customElements.define('ls-wishlist-campaign', LoveShopWishlistCampaign);
})();

  } catch(e) { console.error(e); }
})();
})();
